import React from "react";
import Login from "../pages/Login";
import { IonContent, IonRoute, IonRouterOutlet } from "@ionic/react";
import { Route } from "react-router-dom";
import TrackOrder from "../pages/TrackOrder/v3/TrackOrder";
import MachineLanding from "../pages/MachineLanding";
import { ProtectedRoute } from "./ProtectedRoute";
import DishCustomizations from "../pages/Dish";
import Cart from "../pages/Cart/Cart";
import OrderStatus from "../pages/OrderStatus";
import SelectKiosk from "../pages/SelectKiosk";
import Account from "../pages/Account/Account";
import { IonReactRouter } from "@ionic/react-router";
import Coupons from "../pages/Coupons";
import DietaryPreferences from "../pages/DietaryPreferences";
import OrderDetails from "../pages/Account/OrderDetails";
import Checkout from "../pages/Checkout";
import AllergensInfo from "../pages/Onboarding/AllergensInfo";
import TrackOrderParent from "../pages/TrackOrder/TrackOrderParent";
import GuestTrackOrder from "../pages/TrackOrder/GuestTrackOrder";
import AuthExpired from "../pages/AuthExpired";

export const Routes = (props: any) => {
	const { isAuthenticated } = props;

	//Bug in IonRouterOutlet :
	//If Public Route of login is placed before Protected Route ProtectedComponents the login ProtectedComponent is never reached even if the route is reached

	return (
		<IonContent fullscreen>
			<IonReactRouter>
				{/* Private Routes */}
				<ProtectedRoute ProtectedComponent={SelectKiosk} path="/" isAuthenticated={isAuthenticated} />
				<ProtectedRoute ProtectedComponent={SelectKiosk} path="/kiosk" isAuthenticated={isAuthenticated} />
				<ProtectedRoute ProtectedComponent={MachineLanding} path="/kiosk/:kioskId" isAuthenticated={isAuthenticated} />
				<ProtectedRoute
					GuestComponent={GuestTrackOrder}
					ProtectedComponent={TrackOrderParent}
					path="/kiosk/:kioskId/order/track/:id"
					isAuthenticated={isAuthenticated}
				/>
				<ProtectedRoute
					ProtectedComponent={DishCustomizations}
					path="/kiosk/:kioskId/:brandId/dish/:dishId"
					isAuthenticated={isAuthenticated}
				/>
				<ProtectedRoute ProtectedComponent={Cart} path="/kiosk/:kioskId/cart" isAuthenticated={isAuthenticated} />
				<ProtectedRoute ProtectedComponent={Coupons} path="/kiosk/:kioskId/coupons" isAuthenticated={isAuthenticated} />
				<ProtectedRoute
					ProtectedComponent={OrderStatus}
					path="/kiosk/:kioskId/order/status/:orderId"
					isAuthenticated={isAuthenticated}
				/>
				<ProtectedRoute ProtectedComponent={Account} path="/account" isAuthenticated={isAuthenticated} />
				<ProtectedRoute
					ProtectedComponent={DietaryPreferences}
					path="/account/dietaryPreferences"
					isAuthenticated={isAuthenticated}
				/>
				<ProtectedRoute ProtectedComponent={OrderDetails} path="/account/order/:orderId" isAuthenticated={isAuthenticated} />
				{/* <ProtectedRoute ProtectedComponent={Checkout} path="/kiosk/:kioskId/checkout" isAuthenticated={isAuthenticated} /> */}
				<ProtectedRoute ProtectedComponent={AllergensInfo} path="/onboard/allergens/info" isAuthenticated={isAuthenticated} />
				<ProtectedRoute
					ProtectedComponent={DietaryPreferences}
					componentProps={{ initialSetup: true }}
					path="/onboard/allergens/set"
					isAuthenticated={isAuthenticated}
				/>

				{/* Public Routes */}

				<Route path="/login" exact={true} render={() => <Login />} />
				<Route path="/auth/expired" exact={true} render={() => <AuthExpired />} />
			</IonReactRouter>
		</IonContent>
	);
};
